module.exports = __webpack_public_path__ + "images/emoji/tropical_drink.1896020e28ac79b84295.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tropical_drink.png
// module id = YLIS
// module chunks = 1